import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ChosenPluginsModule} from '../../components/chosen-plugins/chosen-plugins.module';
import {ImageCropperPluginsModule} from '../../components/image-cropper-plugins/image-cropper-plugins.module';
import {AuthGuardService} from '../../services/auth-guard/auth-guard.service';
import {MentalsealAdminService} from '../../services/entity-base/entity-service/mentalseal-admin.service';
import {ChangeDptService} from '../../services/entity-base/entity-service/ownerRoleManage/change-department.service';
import {OrganizationDptAdminService} from '../../services/entity-base/entity-service/ownerRoleManage/organization-dpt-admin.service';
import {OrganizationForAdminService} from '../../services/entity-base/entity-service/ownerRoleManage/organization-for-admin.service';
import {IndexPluginsService} from '../../services/index/index-plugins.service';
import {IndexOperationRoutingModule} from './index-operation-routing.module';
import {IndexFootingComponent} from './index/index-footing/index-footing.component';
import {IndexHeadingComponent} from './index/index-heading/index-heading.component';
import {IndexSideComponent} from './index/index-side/index-side.component';
import {IndexTopComponent} from './index/index-top/index-top.component';
import {IndexComponent} from './index/index.component';

/**
 * @author Dongsj
 * @module [Module]index-operation
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ChosenPluginsModule,
    IndexOperationRoutingModule,
    ImageCropperPluginsModule
  ],
  declarations: [IndexComponent, IndexSideComponent, IndexTopComponent, IndexHeadingComponent, IndexFootingComponent],
  providers: [AuthGuardService, MentalsealAdminService, OrganizationDptAdminService, OrganizationForAdminService, ChangeDptService,
              IndexPluginsService]
})
export class IndexOperationModule {
}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/module/index-operation/index-operation.module.ts